import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IPricingProfilePartNumber } from 'pricing/types';
import { Color } from 'theme/enums';

import { UpsertPricingProfilePartNumber } from './UpsertPricingProfilePartNumber';

interface IProps {
  pricingProfilePartNumber?: IPricingProfilePartNumber;
  structureId: number;
  buttonElement?: ReactElement;
  onSubmitSuccess: () => void;
  onRemoveSuccess?: () => void;
  disabled?: boolean;
}

export const UpsertPricingProfilePartNumberButton = ({
  pricingProfilePartNumber,
  structureId,
  buttonElement,
  onSubmitSuccess,
  onRemoveSuccess,
  disabled = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onClose = () => {
    setIsOpen(false);
  };

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: disabled ? undefined : () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelAddPricingProfilePartNumber')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      />
    );
  }, [buttonElement, disabled, t]);

  return (
    <>
      {button}

      <UpsertPricingProfilePartNumber
        pricingProfilePartNumber={pricingProfilePartNumber}
        structureId={structureId}
        isOpen={isOpen}
        onClose={onClose}
        onSubmitSuccess={onSubmitSuccess}
        onRemoveSuccess={onRemoveSuccess}
      />
    </>
  );
};
